export class OrderBillingDto {
  clientId: number;
  businessName: string;
}
